import { autoinject } from 'aurelia-framework';
import { QueryFilter } from 'lib/tables/DataFilter';
import { Models } from 'models/core';
import { AuthHttpClient } from 'services/auth-http-client';
import { BaseApiService } from 'services/base-api-service';

@autoinject
export class DetergentTypeService extends BaseApiService<Models.DetergentType> {
  constructor(httpClient: AuthHttpClient) {
    super(httpClient, Models.DetergentType);
  }

  public getDetegentTypeList(filters: QueryFilter) {
    return this.httpClient.execWithResponseMeta<any[]>(`${Models.DetergentType.ApiUrl}/list${filters.asQueryString}`, {
      method: 'GET',
    });
  }

  public async checkDuplicate(data: Models.CheckDuplicateDetergentType) {
    return await this.httpClient.exec<{ IsDuplicate: boolean }>(`${Models.DetergentType.ApiUrl}/checkDuplicate`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }
}
